import { render } from "./ProjectPanelsPositioningComponent.vue?vue&type=template&id=660cf256&scoped=true&ts=true"
import script from "./ProjectPanelsPositioningComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectPanelsPositioningComponent.vue?vue&type=script&lang=ts"

import "./ProjectPanelsPositioningComponent.vue?vue&type=style&index=0&id=660cf256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660cf256"]])

export default __exports__